<div class="e-frequency-selector">
    <span>Shown as:</span>
    <mat-form-field appearance="fill" class="e-inline-mat-select">
        <mat-select [(ngModel)]="selectedPeriodRanges" name="periodRanges" panelClass="e-inline-mat-select-panel e-frequency-panel">
            <mat-option *ngFor="let opt of periodRanges" [value]="opt.value">
                {{opt.label}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
